import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import { DEFAULT_CURRENCY, TenantCurrency } from 'src/common/currency';

/**
 * The currency every monetary value in the signed-in user's tenant is displayed in.
 *
 * Falls back to sterling while `/me` is in flight so money never renders unlabelled.
 * Every tenant is GBP unless explicitly switched, so for almost all of them the
 * fallback and the resolved value are identical and nothing flickers.
 */
export function useCurrency(): TenantCurrency {
  const { currentUser } = useCurrentUser();
  return currentUser?.tenantCurrency ?? DEFAULT_CURRENCY;
}
